<template>
    <div v-if="false"></div>
</template>
<script>
export default {
  props: {
    headers: {
      required: true
    },
    columnsSelected: {
      required: true
    },
    items: {
      required: true
    },
    loadData: {
      required: true
    },
    processButtonAction: {
      required: true
    }
  },
  setup (props) {
    return {
    }
  }
}
</script>
